
const monthMap = {
    '01': 'Jan',
    '02': 'Feb',
    '03': 'March',
    '04': 'Apr',
    '05': 'May',
    '06': 'Jun',
    '07': 'July',
    '08': 'August',
    '09': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec'
};

const transfromDateToTargetFormat = (date: string) => {
    if (date.length >= 10) {
        const subDate = date.substring(0, 10);
        const dateArr = subDate.split('/');
        const dateString = `_${monthMap[dateArr[1]]} ${dateArr[2]} ${dateArr[0]}`;
        return dateString;
    }
    return date;
};

const transfromDateToSampleDetailFormat = (date: string) => {
    if (date.length >= 10) {
        const subDate = date.substring(0, 10);
        const dateArr = subDate.split('/');
        const dateString = `${dateArr[2]} ${monthMap[dateArr[1]]} ${dateArr[0]}`;
        return dateString;
    }
    return date;
};


const transfromDateToLayerDetailDateFormatter = (date: string, isSampleDate: boolean) => {
    //2022-Jul-11 05:14 AM
    if (!date) {
        return;
    }
    if (date.length >= 10) {
        const dateArr = date.split(' ');
        const dayMonthYear = dateArr[0];
        const tailString = `${dateArr[1]} ${dateArr[2]}`;
        let dayMonthYearArr = [];
        if (isSampleDate) {
            dayMonthYearArr = dayMonthYear.split('/');
        } else {
            dayMonthYearArr = dayMonthYear.split('-');
        }
        const result = dayMonthYearArr.reverse().join(' ');
        const targetResult = `${result} ${tailString}`;
        if (isSampleDate) {
            return `${dayMonthYearArr[0]} ${monthMap[(dayMonthYearArr[1])]} ${dayMonthYearArr[2]}`;
        }
        return targetResult;
    }
    return date;
};

const transfromDateToLayerDetailSampleDateFormatter = (date: string) => {
    if (date.length >= 10) {
        const dateArr = date.split(' ');
        const dayMonthYear = dateArr[0];
        // const tailString = `${dateArr[1]} ${dateArr[2]}`;

        const dayMonthYearArr = dayMonthYear.split('-');

        const result = dayMonthYearArr.reverse().join(' ');
        // const targetResult = `${result} ${tailString}`;
        return result;
    }
    return date;
};

const transformDateToAMorPMFormat = (date: string, isInProfilePreview?: boolean) => {
    const cacheDataArr = date.split(' ');
    const datePart = cacheDataArr[0].split('/');
    const timePart = cacheDataArr[1].split(':');

    const dayStr = datePart[2];
    const monthStr = datePart[1];
    const yearStr = datePart[0];

    const hourStr = timePart[0];
    const minuteStr = timePart[1];

    const hour = parseInt(hourStr);

    const amOrPm = hour > 12 ? 'PM' : 'AM';
    if (isInProfilePreview) {
        return `${dayStr} ${monthMap[monthStr]} ${yearStr} ${hourStr}:${minuteStr} ${amOrPm}`;
    }
    return `${dayStr}-${monthStr}-${yearStr} ${hourStr}:${minuteStr} ${amOrPm}`;
};

const transformDateToTimeStamp = (date: string) => {
    const formatDate = date.replace(/-/g,'/');
    const dateParam = new Date(formatDate);

    return dateParam.valueOf();
};


const titleCase = (str: string) => {
    const newStr = str.slice(0,1).toUpperCase() +str.slice(1).toLowerCase();
    return newStr;
};

function debounce<T extends (...args: any[]) => any>(func: T, delay: number): T {
    let timer: NodeJS.Timeout | null = null;
    return function (this: any,...args: Parameters<T>): ReturnType<T> | void {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    } as T;
}

const lowerCaseFirstLetter = (str: string): string =>{
    if (str === '') {
        return str;
    }
    return str.charAt(0).toLowerCase() + str.slice(1);
};

export {
    transfromDateToTargetFormat,
    transformDateToTimeStamp,
    transformDateToAMorPMFormat,
    transfromDateToLayerDetailDateFormatter,
    transfromDateToLayerDetailSampleDateFormatter,
    transfromDateToSampleDetailFormat,
    titleCase,
    debounce,
    lowerCaseFirstLetter
};